import { Color, PaletteMode } from '@mui/material';
import { pink as MuiPink } from '@mui/material/colors';
import { PaletteColorOptions, PaletteColor } from '@mui/material/styles';


declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    default: true;
  }
}

declare module '@mui/material/styles' {
  interface Palette {
    default: PaletteColor;

    primary2: PaletteColor;
    secondary2: PaletteColor;
    secondary3: PaletteColor;
    secondary4: PaletteColor;

    pink: Color
  }

  interface PaletteOptions {
    default?: PaletteColorOptions;

    primary2?: PaletteColorOptions;
    secondary2?: PaletteColorOptions;
    secondary3?: PaletteColorOptions;
    secondary4?: PaletteColorOptions;

    pink?: Color;
  }
}

const pink = {
  ...MuiPink,
  100: '#FEEEED',
};

const primary = '#F26E63';
const primary2 = '#818285';
const secondary = '#702771';
const secondary2 = '#3D3950';
const secondary3 = '#A8204E';
const secondary4 = '#D7BC6A';

const palette = (mode: PaletteMode) => {
  return {
    mode,
    default: {
      main: '#ffffff',
      contrastText: '#000',
    },
    primary: {
      main: primary,
      contrastText: '#fff',
    },
    primary2: {
      main: primary2,
    },
    secondary: {
      main: secondary,
    },
    secondary2: {
      main: secondary2,
    },
    secondary3: {
      main: secondary3,
    },
    secondary4: {
      main: secondary4,
    },
    pink,
    // grey,
    // background: {
    //   default: mode === 'light' ? grey['100'] : grey['900'],
    // },
  };
};

export default palette;
